export const SHOW_MODAL = "@modal/SHOW_MODAL";
export const DISMISS_MODAL = "@modal/DISMISS_MODAL";